<!-- <div class="search-div">
    <mat-form-field class="search-form-field">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" [(ngModel)]="filterName" name="filterName">
        <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)= "onClear()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div> -->

<mat-toolbar class="toolbar-example">
    <span>Choose Candidates</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<div class="search-div">
    <mat-form-field class="search-form-field">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter" [(ngModel)]="filterName" name="filterName">
        <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)= "onClear()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>
<div class="candidate-table">
    <table mat-table [dataSource]="listData" class="mat-elevation-z8" matSort>

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef> Sl No. </th>
            <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </td>
        </ng-container>

        <!-- Selection Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row; let i = index;">
                <div *ngIf="(row.panelCandidates?.length > 0 )">
                    <div *ngIf="row.panelCandidates[0].attendance != 1">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                    </div>
                </div>

                <div *ngIf="(row.panelCandidates?.length > 0 )">
                    <div *ngIf="(row.panelCandidates[0].status == 1)">
                        <span class="material-icons">loop</span>
                    </div>
                    <div *ngIf="row.panelCandidates[0].status == 2">
                        <span class="material-icons" matTooltip="Selected">check_circle</span>
                    </div>
                    <div *ngIf="row.panelCandidates[0].status == 3">
                        <span class="material-icons" matTooltip="Rejected">cancel</span>
                    </div>
                </div>

                <div *ngIf="(row.panelCandidates?.length == 0 )">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </div>
            </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="candidateName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Candidate Name </th>
            <td mat-cell *matCellDef="let element"> {{element.candidateName}}</td>
        </ng-container>

        <!-- Assigned/Not Assigned status Column -->
        <ng-container matColumnDef="assignStatus">
            <th mat-header-cell *matHeaderCellDef>Interview Status </th>
            <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="element.panelCandidates[0]; else uncompleted">
                    <ng-container *ngIf="(element.panelCandidates[0].status  ===  2 || element.panelCandidates[0].status  ===  3); else assignedCand">
                        {{element.panelCandidates[0].status  ===  2 ? 'Selected' : 'Rejected'}}
                    </ng-container>
                    <ng-template #assignedCand>
                       Assigned
                    </ng-template>
                </ng-container>
            <ng-template #uncompleted>
                    Not Assigned
            </ng-template>
        </td>
        </ng-container>

        <!-- Email-Id Column -->
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        <!-- Contact No. Column -->
        <!-- <ng-container matColumnDef="contactNo">
            <th mat-header-cell *matHeaderCellDef> Contact No. </th>
            <td mat-cell *matCellDef="let element"> {{element.contactNo}} </td>
        </ng-container> -->

        <!-- City Column -->
        <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
            <td mat-cell *matCellDef="let element"> {{element.address}} </td>
        </ng-container>

        <!-- Total Score  Column -->
        <ng-container matColumnDef="totalMarks">
            <th mat-header-cell *matHeaderCellDef> Total Marks </th>
            <td mat-cell *matCellDef="let element"> {{element.totalMarks}} </td>
        </ng-container>

        <!-- Secured Score Column -->
        <ng-container matColumnDef="score">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Secured Score </th>
            <td mat-cell *matCellDef="let element"> {{element.score}} </td>
        </ng-container>

        <!-- Gender Column -->
        <ng-container matColumnDef="gender">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Candidate Gender </th>
            <td mat-cell *matCellDef="let element"> {{element.gender}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
            class="example-element-row"></tr>
    </table>

    <!-- <mat-form-field [hidden]="true"> -->
        <input matInput [(ngModel)]="element" [hidden]="true">
    <!-- </mat-form-field> -->
</div>
<div class="button-row action-btn">
    <button mat-raised-button class="btn-color-example" [mat-dialog-close]="element" (click)='candidateChanged()'>Apply</button>
    <button mat-raised-button class="btn-cancel" [mat-dialog-close]>Close</button>
</div>